function extractParts(code: string) {
  const parts = code.split('-');
  return { xx: parseInt(parts[1], 10), yy: parseInt(parts[2], 10) };
}

export function sortByTaskCode(tasks: Record<string, unknown>): Record<string, unknown> {
  const sorted = Object.fromEntries(
    Object.entries(tasks).sort(([keyA], [keyB]) => {
      const a = extractParts(keyA);
      const b = extractParts(keyB);

      return a.xx - b.xx || a.yy - b.yy;
    }),
  );
  return sorted;
}
